export interface ISignalR {
  start(): Promise<any>;

  stop(): Promise<any>;

  on(name: string, callback: (data: any) => void): void;

  invoke(name: string, args?: any): Promise<any>;
}
